<template>
  <div>
    <div class="app-content content" v-show="!showUpdate">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="POS Devices"
                bc1="App"
                bc2="POS Devices"
                bc3="List"
                path="pos-devices"
            ></Breadcrumb>
          </div>
          <div
              class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
          >

          </div>
        </div>
        <div class="content-body">
          <div class="accordion" id="searchFilterAccordion">
            <div class="card">
              <div class="card-header" id="searchFilterHeading">
                <h5 class="mb-0">
                  <button
                      class="btn btn-link text-primary"
                      type="button"
                      data-toggle="collapse"
                      data-target="#searchFilterCollapse"
                      aria-expanded="false"
                      aria-controls="searchFilterCollapse"
                  >
                    Search Filters
                    <i class="ml-25 fas fa-chevron-down"></i>
                  </button>
                </h5>
              </div>
              <div
                  id="searchFilterCollapse"
                  class="collapse"
                  aria-labelledby="searchFilterHeading"
                  data-parent="#searchFilterAccordion"
              >
                <div class="card-body">
                  <div class="d-flex align-items-center mx-50 row pt-0 pb-2">
                    <div class="col-lg-4 mb-1 col-sm-12">
                      <input
                          class="form-control"
                          @keyup.enter="onSubmitFilters"
                          type="text"
                          v-model="search"
                          placeholder="Search here..."
                      />
                    </div>
                    <div class="col-lg-4 mb-1 col-sm-12">
                      <button
                          type="button"
                          class="btn btn-primary"
                          @click="onSubmitFilters"
                      >
                        Search
                      </button>
                      <button
                          type="button"
                          class="ml-1 btn btn-danger"
                          @click="clear"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="m-2">
              <div class="row">
                <div class="col-md-12 col-12">
                  <div class="d-flex align-items-center justify-content-end">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="$router.push({ name: 'add-pos-devices' })"
                    >
                      <AddButtonText name="POS Device" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CommonTableStore
                ref="commonTable"
                :url="url"
                :filtered-data="data"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :force="force"
                :storageKey="storageKey"
                :externalTotalRecord="externalTotalRecord"
                :show-per-page="true"
                :selectable="true"
                selectionKey="id"
                :selectionCondition="selectionCondition"
                @selectionChanged="onSelectionChanged"
            >
              <template v-slot:bulkActions="{ selectedCount }">
                <button
                    type="button"
                    class="btn-sm btn btn-gradient-secondary"
                    :disabled="!selectedCount"
                    @click="openBulkSoftPosModal"
                >
                  <feather type="smartphone"></feather>
                  Register SoftPOS
                </button>
              </template>
            </CommonTableStore>
          </div>
        </div>
      </div>
    </div>
    <UpdatePOS @back="showUpdate = false" v-if="showUpdate"  />
    <TreeModal  @updateTreeRecord="updatedTreeVal" :editable="true" :show="showOtherInfo" :treeData="otherInfoData" @hide="showOtherInfo= false"></TreeModal>
    <SoftPosRegistrationModal
      :show="showSoftPosModal"
      :row="softPosSelectedRow"
      :rows="softPosSelectedRows"
      :storageKey="storageKey"
      @hide="showSoftPosModal = false"
      @refresh="onSoftPosRegistered"
    />
    <SoftPosBindingModal
      :show="showBindingModal"
      :row="bindingSelectedRow"
      :storageKey="storageKey"
      @hide="showBindingModal = false"
      @refresh="force = !force"
    />
  </div>
</template>

<script>
import UpdatePOS from "@/pages/dashboard/pos/UpdatePOS.vue";
import TreeModal from "@/pages/dashboard/merchant/logs/Tree.vue";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";
import SoftPosRegistrationModal from "@/pages/dashboard/pos/SoftPosRegistrationModal.vue";
import SoftPosBindingModal from "@/pages/dashboard/pos/SoftPosBindingModal.vue";

export default {
  components: {
    AddButtonText,
    TreeModal,
    UpdatePOS,
    SoftPosRegistrationModal,
    SoftPosBindingModal
  },
  created() {
    this.url = "v1/get-pos-device";
  },
  mounted() {
    localStorage.setItem("url", "v1/get-pos-device");
    this.checkDataInStore('v1/get-pos-device')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      data: { flag: "all",thirdPartyReferences:1, bindings:1 },
      url: "v1/get-pos-device",
      force:false,
      storageKey: "pos",
      showUpdate:false,
      showOtherInfo:false,
      otherInfoData:{},
      selectedRow: null,
      showSoftPosModal: false,
      softPosSelectedRow: null,
      softPosSelectedRows: [],
      selectedPosRows: [],
      /* only SoftPOS devices with an assigned channel and no third party reference yet can be bulk registered */
      selectionCondition: (row) => {
        let hasChannel = Array.isArray(row.channels) && row.channels.length > 0
        let hasNoReference = !row.thirdparty_references || (Array.isArray(row.thirdparty_references) && row.thirdparty_references.length === 0)
        return row.type === 2 && hasChannel && hasNoReference
      },
      showBindingModal: false,
      bindingSelectedRow: null,
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true,
          alter: function(value, row) {
            let typeLabel = row.type == 1 ? 'POS' : row.type == 2 ? 'SoftPOS' : row.type || '';
            let html = `<p class="text-primary mb-25" >${value}</p>`
            if (row.type) {

              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-light-primary" >${typeLabel}</div>
                    </div>
                </div>
                `
            }

            return html;
          }
        },
        {
          title: "Device Model",
          valueKey: "device_model",
          alter: function(value) {
            return value
          }
        },
        {
          title: "Device ID",
          valueKey: "device_id",
          alter: function(value) {
            return value
          }
        },
        {
          title: "Serial ID",
          valueKey: "serial_number",
          alter: function(value) {
            return value
          }
        },
        {
          title: "Assigned Channel",
          valueKey: "channels",
          html: true,
          alter: (value) => {
            if(value && value.length > 0){
              return `
                <div class="row">
                    <div class="col-12">
                        <div class=""><span class="text-primary badge">${value[0].name + '/' + value[0].code }</span></div>
                        <div class="badge badge-light-primary mt-1">${value[0].user?.email}</div>
                    </div>
                </div>
                `
            }
            return `<a href="javascript:void()" class="badge badge-light-warning">Channel Not Assigned</a>`
          }
        },
        {
          title: "IMEI",
          valueKey: "imei_number",
          alter: function(value) {
            return value
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }
            return html;
          }
        },
        {
          title: "Created At",
          valueKey: "created_at",
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
        {
          title: "Updated At",
          valueKey: "updated_at",
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          title: "Update",
          class: "badge btn-primary",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "posUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true
          }
        },
        {
          title: "Details",
          class: "badge btn-primary",
          cta: (row, index) => {
            this.otherInfoData = row?.other_details ? JSON.parse(row?.other_details) :  {}
            this.selectedRow = row
            this.showOtherInfo = true
          }
        },
        {
          title: "Register SoftPOS",
          class: "badge btn-secondary",
          conditionalRendering:true,
          condition: (row) => row.type === 2,
          cta: (row, index) => {
            this.softPosSelectedRow = row
            this.softPosSelectedRows = []
            this.showSoftPosModal = true
          }
        },
        {
          title: "Bound Device",
          class: "badge btn-info",
          conditionalRendering:true,
          condition: (row) => !!row.binding,
          cta: (row, index) => {
            this.bindingSelectedRow = row
            this.showBindingModal = true
          }
        },
      ],
      deleteActions: [
      ],
      mutedData: [],
      externalTotalRecord: "",
      search: "",
    };
  },
  methods: {
    onSelectionChanged(selection) {
      this.selectedPosRows = selection.rows
    },
    openBulkSoftPosModal() {
      if (!this.selectedPosRows.length) {
        return
      }
      this.softPosSelectedRow = null
      this.softPosSelectedRows = [...this.selectedPosRows]
      this.showSoftPosModal = true
    },
    onSoftPosRegistered() {
      if (this.$refs.commonTable) {
        this.$refs.commonTable.clearSelection()
      }
      this.softPosSelectedRows = []
      this.force = !this.force
    },
    updatedTreeVal(val) {
      let row = this.selectedRow
      if(!row){
        return
      }

      let data = {
        id: row.id,
        name: row.name,
        posDeviceId: row.device_id,
        imeiNumber: row.imei_number,
        serialNumber: row.serial_number,
        posDeviceModel: row.device_model,
        status: row.status,
        type: row.type,
        details: JSON.stringify(val)
      }

      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest("post", "v1/update-pos-device", data).then(
          callResponse => {
            this.$store.dispatch('exportExcelLoader', false)
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.force = !this.force
                this.showOtherInfo = false
              }

            }
            this.loading = false;
          }
      );
    },
    onSubmitFilters() {

      let filterData = { flag: "all", thirdPartyReferences: 1, bindings: 1 }


      if(this.search != ''){
        filterData.search = this.search
      }

      this.data = filterData

    },
    clear(){
      this.search = ''
      this.data = { flag: "all", thirdPartyReferences: 1, bindings: 1 }
    },
  }
};
</script>

